import user from '../../assets/icons/user.svg';
export interface ProfileAvatarProps {
  imgSrc?: string;
  onClick?: () => void;
  largerSize?: boolean;
}
export const ProfileAvatar = ({
  imgSrc = '',
  onClick,
  largerSize = false,
}: ProfileAvatarProps) => {
  const cursorClass = onClick ? 'cursor-pointer' : 'cursor-default';
  const sizeClass = largerSize ? 'size-16' : 'size-8';
  const imgSizeClass = largerSize ? 'w-20' : 'w-10';
  return (
    <div
      className={`flex ${sizeClass} ${cursorClass} items-center justify-center overflow-hidden rounded-full`}
      onClick={onClick}
    >
      {imgSrc ? (
        <img
          src={imgSrc}
          alt="Profile Avatar"
          className="size-full object-cover"
        />
      ) : (
        <img
          src={user}
          alt="user"
          className={imgSizeClass}
          draggable={false}
        />
      )}
    </div>
  );
};
